import React from "react";
import { type Without } from "../../types/internal/utility";

// Look at DataSource.tsx InjectedDataSourceProps for best practises
export interface InjectedMediaQueryProps {
    matchesMedia: boolean;
}

interface WithMediaQueryState {
    matches: boolean;
}

export default function withMediaQuery<
    C extends React.ComponentType<React.ComponentProps<C> & InjectedMediaQueryProps>,
    WrappedProps = React.JSX.LibraryManagedAttributes<C, Without<React.ComponentProps<C>, InjectedMediaQueryProps>>
>(
    WrappedComponent: C,
    query: string
): React.ComponentType<WrappedProps> {
    return class extends React.Component<
        WrappedProps,
        WithMediaQueryState
    > {
        public static displayName = "WithMediaQuery";

        public mediaQuery = window.matchMedia(query);

        constructor(props: WrappedProps) {
            super(props);

            this.state = {
                matches: this.mediaQuery.matches,
            };
        }

        public componentDidMount(): void {
            this.mediaQuery.addEventListener("change", this.onMedia);
        }

        public componentWillUnmount(): void {
            this.mediaQuery.removeEventListener("change", this.onMedia);
        }

        public onMedia = (e: MediaQueryListEvent): void => {
            this.setState({
                matches: e.matches,
            });
        };

        public render(): React.ReactNode {
            return (
                <WrappedComponent
                    {...this.props as any}
                    matchesMedia={this.state.matches}
                />
            );
        }
    };
}
